export function updateTools(payload) {
  return dispatch => {
    dispatch({ type: 'UPDATE_TOOLS', payload: payload });
  };
}

export function nilSingleScore() {
  return dispatch => {
    dispatch({
      type: 'UPDATE_TOOLS',
      payload: {
        active: null,
        dollarsGained: 0,
      },
    });
  };
}

export function updateScoreFromSimulations(label, jobs, before, after) {
  if (after) {
    const years = 100 - jobs.primary_retirement_age;
    const rsp_diff = after.scores.retirement_spending_power - before.scores.retirement_spending_power;
    return dispatch => {
      dispatch({
        type: 'UPDATE_TOOLS',
        payload: {
          active: label,
          dollarsGained: years * rsp_diff,
        },
      });
    };
  } else {
    return dispatch => {};
  }
}
